module.exports = __webpack_public_path__ + "img/9791186510537.79a8247f.jpg";